import { useTranslation } from "react-i18next";
import { useSubmitFranchiseFormMutation } from "../api/franchiseApi";
import { useMutationWithFeedback } from "../../../common/hooks/useMutationWithFeedback";
import type {
  FranchiseFormPayload,
  FranchiseFormResponse,
} from "../types/franchiseApiTypes";

export const useSubmitFranchiseForm = () => {
  const { t } = useTranslation();
  const [submitMutation, result] = useSubmitFranchiseFormMutation();

  const {
    trigger: submitFranchiseForm,
    isLoading,
    isSuccess,
  } = useMutationWithFeedback<FranchiseFormResponse, FranchiseFormPayload>({
    mutation: [submitMutation, result],
    loadingMessage: t("franchiseForm.sending", "Sending application..."),
    successMessage: t(
      "franchiseForm.success",
      "Application sent successfully. We will get back to you soon."
    ),
    errorMessages: {
      default: t(
        "franchiseForm.error",
        "Failed to send application. Please try again."
      ),
    },
    successToastType: "success",
  });

  return {
    submitFranchiseForm,
    isLoading,
    isSuccess,
    isError: result.isError,
  };
};
